import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ProductLineTitleStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductLineNameStyled = styled.span`
  margin-left: 0.5rem;
  font-size: 1.8rem;
  line-height: 2.4rem;
  font-weight: 700;
  color: ${colors.neutral[900]};
`;
